import React, { Component, Fragment } from 'react';
import InputRange from 'react-input-range';

/**
 * I used local state with redux-form, because InputRange onChange method throws values to redux
 * store to often and application may freeze
 */
class InputRangeOrigin extends Component {
  render() {
    const {
      input,
      rangeInputValue,
      handleChangeRange,
      landing,
      ...props
    } = this.props;

    return (
      <Fragment>
        <InputRange
          maxValue={12}
          minValue={1}
          value={rangeInputValue}
          onChange={handleChangeRange}
        />
        <div className="pricing-itm-value">
          x{rangeInputValue} {landing && 'Domains'}
        </div>
      </Fragment>
    );
  }
}

export default InputRangeOrigin;



// WEBPACK FOOTER //
// ./src/components/PricingPlans/InputRange.js